import { IBouncer } from 'js/bubbleCore/types';
import { convertHexLimitsToSpaceLimits } from 'js/bubbleCore/utils/convertHexLimitsToSpaceLimits';
import { RandomDataGenerator } from 'framework/RandomDataGenerator/RandomDataGenerator';
import { ILevelDataPointZone } from 'js/bubbleCore/levelParser/parseLevel';
import { ISpace } from 'framework/utils/math-utils';

export function generateBouncers(
  rnd: RandomDataGenerator,
  data: ILevelDataPointZone[],
  bouncerWidth: number,
  space: ISpace,
): IBouncer[] {
  const result: IBouncer[] = [];

  const spaceWidth = space.right - space.left;
  const bouncerSpaceWidth = spaceWidth * bouncerWidth;

  for (let i = 1; i < data.length; i++) {
    const prev = data[i - 1];
    const current = data[i];

    const bouncerCenterX = (
      current.x * spaceWidth
    );

    result.push({
      id: rnd.uuid(),
      size: {
        x: space.left + (current.x * spaceWidth) - (bouncerSpaceWidth * 0.5),
        y: space.top,
        width: bouncerSpaceWidth,
        height: 1,
      },
    });
  }

  return result;
}